export const GET_TYPE_ORDER = 'GET_TYPE_ORDER'
export const GET_TYPE_ORDER_EXITO = 'GET_TYPE_ORDER_EXITO'
export const GET_TYPE_ORDER_ERRROR = 'GET_TYPE_ORDER_ERROR'
